export default __webpack_public_path__ + "static/media/1-table-4-chair.43077a3b.png";